import { render, staticRenderFns } from "./terUserAction.vue?vue&type=template&id=e44ffd24&scoped=true"
import script from "./terUserAction.vue?vue&type=script&lang=js"
export * from "./terUserAction.vue?vue&type=script&lang=js"
import style0 from "./terUserAction.vue?vue&type=style&index=0&id=e44ffd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44ffd24",
  null
  
)

export default component.exports